module.exports = __webpack_public_path__ + "img/fileicon.0119973b.svg";